import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
    // Run again after paint in case React updates DOM later
    const t = setTimeout(scrollToTop, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
